import React from "react";
import "../css/TeeStyles.css";

const SectionOne = () => {
  return (
    <>
      <div
        // data-aos="fade-right"
        data-aos="fade-right"
        className="marginTopSmallNavLong section blackKsb wid100 my-image px-md-4 px-2"
      >
        <div>
          <span className="d-block mx-auto text-center boldSeven fontSize54px pt-9 white">
            Your Vision, Our Expertise
          </span>
          <span className="d-block mx-auto text-center fontSize28px boldSeven pt-5 white">
            Affordable Creative Studio Space For Rent Now In Lagos
          </span>
          <span className="d-block mx-auto boldFive pt-5 fontSize16px wid50 wid50Mobile text-center pb-6 white">
            MCM Studio is an affordable studio space in Gbagada Lagos, whether
            you're recording a podcast, capturing stunning visuals, or hosting a
            seminar, our state-of-the-art studio has everything you need to
            bring your vision to life.
          </span>
        </div>
      </div>
    </>
  );
};
export default SectionOne;
